module.exports = __webpack_public_path__ + "img/twitter_icon.9c7452d5.png";